<template>
  <div class="main-content">
    <div class="register-page">
      <div class="container">
        <h2 class="register-page__login-title">會員註冊</h2>
        <div class="out-side">
          <ValidationObserver ref="form" class="validate-area">
            <div class="location-choose-area">
              <div class="location-choose-area__title">
                分店
              </div>
              <ValidationProvider
                :rules="{
                  required: true
                }"
                v-slot="{ errors, failed }"
                name="location"
              >
                <ul class="location-menu row" :class="{ failedin: failed }">
                  <Location
                    v-for="(oneLocation, index) in locationOptions"
                    :key="index"
                    :oneLocation="oneLocation"
                    v-model="location"
                  />
                </ul>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="single-input-field">
              <p class="input-title">手機號碼</p>
              <ValidationProvider
                :rules="{
                  required: true,
                  regex: /^09\d{8}$/
                }"
                v-slot="{ errors, failed }"
              >
                <div class="custom-input" :class="{ failed: failed }">
                  <input
                    type="text"
                    class="custom-text mobile"
                    :placeholder="'請輸入手機號碼'"
                    name="mobile"
                    v-model="mobile"
                    autocomplete="off"
                  />
                </div>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="single-input-field">
              <p class="input-title">Email</p>
              <ValidationProvider
                :rules="{
                  email: true
                }"
                v-slot="{ errors, failed }"
                name="email"
              >
                <div class="custom-input" :class="{ failed: failed }">
                  <input
                    type="email"
                    class="custom-text email"
                    placeholder="請輸入 Email"
                    name="email"
                    v-model="email"
                    autocomplete="off"
                  />
                </div>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="single-input-field">
              <p class="input-title">生日</p>

              <ValidationProvider
                :rules="{
                  required: true,
                  min: 10,
                  max: 10
                }"
                v-slot="{ errors, failed }"
                name="birthday"
              >
                <DatePicker
                  ref="datePicker"
                  v-model="birthday"
                  type="date"
                  :append-to-body="false"
                  :clearable="false"
                  :format="momentFormat"
                  valueType="YYYY-MM-DD"
                  :class="{ failed: failed }"
                >
                  <span slot="icon-calendar" class="icon-icon_calendar"></span>
                </DatePicker>

                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="single-input-field">
              <p class="input-title">性別</p>

              <ValidationProvider
                :rules="{
                  required: true
                }"
                v-slot="{ errors, failed }"
                name="gender"
              >
                <div class="gender-choose-area" :class="{ failedin: failed }">
                  <div class="custom-radio">
                    <input
                      type="radio"
                      value="1"
                      id="male"
                      v-model="gender"
                      class="gender-radio"
                    />
                    <label for="male">男性</label>
                  </div>

                  <div class="custom-radio">
                    <input
                      type="radio"
                      value="0"
                      id="female"
                      v-model="gender"
                      class="gender-radio"
                    />
                    <label for="female">女性</label>
                  </div>
                </div>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </div>
        <button class="confirm-btn custom-btn" @click="submit">確認</button>
      </div>
    </div>
    <RegisterSuccess :phone="member.phone" />
    <AlreadyMember />
    <AlreadyAppMember />
  </div>
</template>

<script>
import { localize } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';
import Location from '@/components/Register/Location';
import RegisterSuccess from '@/components/Modal/RegisterSuccess';
import AlreadyMember from '@/components/Modal/AlreadyMember';
import AlreadyAppMember from '@/components/Modal/AlreadyAppMember';
import { fetchBranches } from '@/api/branch';
import { registerMember } from '@/api/register';
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  components: {
    Location,
    RegisterSuccess,
    AlreadyMember,
    AlreadyAppMember
  },
  data() {
    return {
      mobile: '',
      uniformNum: '',
      phone: '',
      location: '',
      birthday: '',
      gender: '',
      email: '',
      locationOptions: [],
      member: [],
      momentFormat: {
        //[可选] Date to String
        stringify: date => {
          return date ? moment(date).format('YYYY-MM-DD') : '';
        },
        //[可选]  String to Date
        parse: value => {
          return value ? moment(value, 'YYYY/MM/DD').toDate() : null;
        }
      }
    };
  },
  created() {
    localize({
      zh_TW: {
        messages: zh_TW.messages,
        names: {
          location: '分店',
          mobile: '手機號碼',
          birthday: '生日',
          gender: '性別',
          email: 'Email'
        },
        fields: {
          location: {
            required: '請選擇分店'
          },
          mobile: {
            required: '此欄位必填'
          },
          birthday: {
            required: '此欄位必填',
            max: '生日不能大於8個字元'
          },
          gender: {
            required: '請選擇性別'
          },
          email: {
            email: '請輸入有效的 Email 格式'
          }
        }
      }
    });

    this.fetchBranches();

    this.clearBranch();
  },
  methods: {
    ...mapActions('user', ['clearBranch']),
    submit() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const payload = {
            branch_id: this.location,
            phone: this.mobile,
            birthday: this.birthday,
            gender: this.gender
          };
          if (this.email && this.email.trim() !== '') {
            // 使用者有輸入才附加
            payload.email = this.email.trim();
          }

          registerMember(
            payload,
            registerCb => {
              this.member = registerCb.member;
              this.$bvModal.show('register-success-modal');
            },
            errCb => {
              if (errCb === '4009') {
                this.$bvModal.show('already-app-member-modal');
              } else {
                this.$bvModal.show('already-member-modal');
              }
            }
          );
        } else {
          alert('欄位填寫錯誤');
        }
      });
    },
    fetchBranches() {
      fetchBranches(branches => {
        this.locationOptions = branches;
      });
    }
  }
};
</script>
